export default class PostPassword{
	constructor(){
		this.holderClass = '.pw-protected'
		this.form = (e) => e.target.closest(`#pw_form`);
		this.button = (e) => this.form(e) && this.form(e).querySelector('button');
		this.password = (e) => this.form(e) && this.form(e).querySelector('[name="post_password"]');
		window.addEventListener('submit', this.check.bind(this) );
		window.addEventListener('input', this.checkEmpty.bind(this) );
	}
	check(e){
		const form = this.form(e);
		if( form !== e.target ) return;
		e.preventDefault();

		const postId = form.dataset.postId;
    const password = this.password(e).value;
		const button = this.button(e);

		password === '' && form.closest(this.holderClass).classList.remove('is-error');
		form.closest(this.holderClass).classList.add('is-loading');

		fetch(atnlbs_default.wp_rest_url + "pw/v0/pw", {
			method: 'POST',
			headers: {
					'Content-Type': 'application/json',
					'X-WP-Nonce': atnlbs_default.nonce
			},
			body: JSON.stringify({
					post_id: postId,
					password: password
			})
		}).then(response => response.json())
    .then(data => {
        if (data.success) {
					form.closest(this.holderClass).classList.add('is-success');
					form.closest(this.holderClass).classList.remove('is-error');
					form.closest(this.holderClass).classList.remove('is-invalid');
					form.closest(this.holderClass).classList.remove('is-loading');
					button.removeAttribute('disabled');
					setTimeout(() => {
						form.submit();
					}, parseInt(form.dataset.submitDelay) );
					return;
				}
				form.closest(this.holderClass).classList.add( data.success === false ? 'is-invalid' : 'is-error');
				form.closest(this.holderClass).classList.remove('is-loading');
    });
	}

	checkEmpty(e){
		const form = this.form(e);
		const button =  this.button(e);
		const password = this.password(e);
		if( password !== e.target || ! button ) return;
		form.closest(this.holderClass).classList.remove('is-invalid');
		form.closest(this.holderClass).classList.remove('is-error');
		password.value === "" ? button.setAttribute('disabled', true) : button.removeAttribute('disabled');
	}
}
